import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer.component';
import { LibrariesModule } from '../../libraries/libraries.module';
import { SharedModule } from '../../shared/shared.module';
import { QRCodeModule } from 'angularx-qrcode';



@NgModule({
  declarations: [FooterComponent],
  imports: [
    CommonModule,
    LibrariesModule,
    SharedModule,
    QRCodeModule
  ],
  exports: [FooterComponent]
})
export class FooterModule { }
